<div class="contractor-list-container">
  <div class="contractor-list-search">
    <div class="contractor-title">
      <span>Skills</span>
    </div>
    <div class="search-bar-container">
      <div class="search-child">
        <emerald-input
          [label]="'Search'"
          [trailingIcon]="'search'"
          (keyup)="searchContractors($event)"
          [value]="filterValue"
          ><emerald-icon
            *ngIf="filterValue?.length && filterValue.length > 0"
            [icon]="'close'"
            (click)="clearInput()"
          ></emerald-icon>
        </emerald-input>
      </div>

      <emerald-menu
        [opened]="opened"
        [position]="'bottom_end'"
        [targetElement]="navTemplate"
        [menuTemplate]="menuTemplate"
        (openChange)="opened = $event"
      ></emerald-menu>
      <ng-template #navTemplate>
        <emerald-button
          [label]="'Filter'"
          [size]="'Small'"
          [type]="'Secondary'"
          [icon]="'filter_list'"
          [iconPosition]="'Left'"
          (onClick)="this.opened = !this.opened"
        ></emerald-button>
      </ng-template>
      <ng-template #menuTemplate>
        <app-vendor-management-filter
          [fieldsVisibility]="fieldsVisibility"
         (filterAppliedSkills)="onFilterApplied($event)"
          [ContractorDataBySkills]="originalData"
        ></app-vendor-management-filter>
      </ng-template>
    </div>
  </div>

  <div class="contractor-list-table">
    <ng-container *ngIf="displayData?.length; else noDataTemplate">
      <emerald-datatable
        [columnDefs]="columnDefs"
        [rowData]="displayData"
        [paginationParams]="paginationParams"
        [customCellTemplate]="{
          contractorName: customContractorNameColumn,
        }"
      >
      </emerald-datatable>
    </ng-container>
    <ng-template #noDataTemplate>
      <section class="records-container" aria-label="Records section">
        <div class="empty-state">
          <ng-container *ngIf="isDataLoaded">
            <h2 class="empty-state-title">{{ errorMsg }}</h2>
          </ng-container>
          <img
            [src]="imageSrc"
            alt="No records illustration"
            class="empty-state-image"
          />
        </div>
      </section>
    </ng-template>
    <ng-template
      #customContractorNameColumn
      let-level="level"
      let-eachRow="eachRow"
    >
      <div class="contractor-info">
        <a
          class="name"
          (click)="navigateToContractorProfile(eachRow.contractorId)"
          >{{ eachRow?.contractorName }}</a
        >
      </div>
    </ng-template>
  </div>
</div>
